import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import Row from 'components/Row';
import Image from 'components/Image';
import Columns2 from 'components/Columns2';
import Text from 'components/Text';
import { SyncType } from 'globalTypes';

type Props = {
  selectSyncType: (method: SyncType) => void;
  onClose: () => void;
  displaySyncType: (syncType: SyncType) => void;
};

class AdminSyncTypeCleverView extends React.Component<Props> {
  handleHideRequest = () => {
    this.props.onClose();
  };

  handleContinue = () => {};

  render() {
    return (
      <React.Fragment>
        <Columns2>
          <Row size="xxxlarge">
            <Row>
              <Text size="small" align="left">
                To connect Clever to Remind, you'll need to be an administrator on Clever.{' '}
              </Text>
            </Row>
            <Text align="left" color="graphite" size="small">
              This will allow you to give permission for Remind to access your school information.{' '}
            </Text>
          </Row>
          <Image src={require('assets/images/rostering/clever.png')} width="80%" />
        </Columns2>
        <Text align="left">
          <Button
            level="secondary"
            onClick={() => {
              this.props.displaySyncType(SyncType.remindSpreadsheetV2);
            }}
            data-test={`button-remind-csv`}>
            Go back
          </Button>{' '}
          <Button
            onClick={() => this.props.selectSyncType(SyncType.clever)}
            data-test={`button-continue`}>
            {' '}
            Continue with Clever{' '}
          </Button>
        </Text>
      </React.Fragment>
    );
  }
}

export default AdminSyncTypeCleverView;
